import { ReactNode } from 'react'
import { TopBar } from './TopBar'

interface DashboardLayoutProps {
  children: ReactNode
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="h-screen flex flex-col bg-background">
      <TopBar />
      <main className="flex-1 overflow-y-auto bg-muted/40">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-8 lg:px-12">
          {children}
        </div>
      </main>
    </div>
  )
}
